// extracted by mini-css-extract-plugin
export var subMenuItem = "style-module--sub-menu-item--c29ce";
export var subMenuItem__dflex = "style-module--sub-menu-item__dflex--d10fb";
export var subMenuItem__label = "style-module--sub-menu-item__label--7c601";
export var subMenuItem__subgroup = "style-module--sub-menu-item__subgroup--a8b36";
export var subMenuItem__subgroupColumns2 = "style-module--sub-menu-item__subgroup--columns-2--b5f93";
export var subMenuItem__subgroupColumns3 = "style-module--sub-menu-item__subgroup--columns-3--4dfcc";
export var subMenuItem__subgroupColumns4 = "style-module--sub-menu-item__subgroup--columns-4--2777d";